import React, {useEffect, useState} from 'react'
import {sanity, urlFor} from '../lib/sanity'

const ABOUT_QUERY = `*[_type == "aboutPage"][0]{
  title,
  body,
  logo,
  logoLink
}`

function About() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    sanity
      .fetch(ABOUT_QUERY)
      .then((result) => {
        setData(result)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }, [])

  if (loading) return null

  if (!data) {
    return (
      <div className="text-start max-w-prose mx-auto my-24 md:my-36 px-8 text-[#5757fd]">
        <p className="text-lg font-sans">Geen content gevonden.</p>
      </div>
    )
  }

  return (
    <div className="text-start max-w-prose mx-auto my-24 md:my-36 px-8">
      <div className="text-[#5757fd] my-12">
        {data.title && (
          <h1 className="text-4xl font-sans mb-8">
            {data.title}
          </h1>
        )}

        {data.body && (
          <p className="text-lg font-sans whitespace-pre-line">
            {data.body}
          </p>
        )}
      </div>

      {data.logo && (
        <div className="overflow-hidden">
          {data.logoLink ? (
            <a
              href={data.logoLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={data.logo?.alt || 'Visit website'}
              className="block w-fit mx-auto"
            >
              <img
                src={urlFor(data.logo).width(520).url()}
                alt={data.logo?.alt || data.title || 'Logo'}
                className="bg-white/60 hover:shadow-[0_18px_40px_rgba(87,87,253,0.22)] rounded-2xl mt-8 mb-24 p-8 w-[260px] mx-auto transition-transform duration-700 hover:scale-105"
              />
            </a>
          ) : (
            <img
              src={urlFor(data.logo).width(520).url()}
              alt={data.logo?.alt || data.title || 'Logo'}
              className="bg-white/60 rounded-2xl mt-8 mb-24 p-8 w-[260px] mx-auto"
            />
          )}
        </div>
      )}
    </div>
  )
}

export default About